import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptors,
  HttpBackend
} from '@angular/common/http';
import { DefaultHttpInterceptor } from './interceptors/default-http.interceptor';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { registerLocaleData } from '@angular/common';
import localsEsUs from '@angular/common/locales/es-US';
import localsEsCo from '@angular/common/locales/es-CO';
import { AuthService } from './services/auth.service';
import { SplitioService } from './services/splitIO/splitio.service';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { environment } from 'src/environments/environment';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './utilities/translation-pagiantor';
import { provideTkTheme } from '@tekus/design-system/core/types';
import { NotificationsComponent } from './components/shared/notifications/notifications.component';
import { ToastrModule } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

export function HttpLoaderFactory(
  _httpBackend: HttpBackend
): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(_httpBackend, [
    { prefix: '/assets/i18n/shared/', suffix: '.json' },
    { prefix: '/assets/i18n/kiosks/', suffix: '.json' },
    { prefix: '/assets/i18n/screens/', suffix: '.json' },
    { prefix: '/assets/i18n/messaging/', suffix: '.json' }
  ]);
}

export function registerLocaleDynamic() {
  let localID = navigator?.language;
  if (
    !localID ||
    (localID !== 'es-CO' &&
      localID !== 'es-US' &&
      localID !== 'es-ES' &&
      localID !== 'en-US')
  ) {
    localID = 'es-CO';
  } else if (localID === 'es-ES' || localID === 'en-US') {
    localID = 'es-US';
  }
  registerLocaleData(localsEsUs, 'es-US');
  registerLocaleData(localsEsCo, 'es-CO');

  return localID;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),

    provideHttpClient(withInterceptors([DefaultHttpInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          deps: [HttpBackend],
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory
        },
        fallbackLang: 'es'
      }),
      ToastrModule.forRoot({
        toastComponent: NotificationsComponent,
        newestOnTop: false,
        preventDuplicates: true,
        autoDismiss: true,
        maxOpened: 5,
        tapToDismiss: false,
        positionClass: 'toast-bottom-center'
      })
    ),
    AuthService,
    SplitioService,
    provideLottieOptions({
      player: () => player
    }),
    provideCharts(withDefaultRegisterables()),
    {
      provide: 'googleTagManagerId',
      useValue: environment.googleTagManagerId
    },
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl()
    },
    {
      provide: LOCALE_ID,
      useFactory: registerLocaleDynamic
    },
    {
      provide: 'PRODUCT_MENU',
      useValue: new BehaviorSubject<{ type: string; tester: boolean }>({ type: '', tester: false })
    },
    provideTkTheme()
  ]
};
